export class PasswordEmailModel {
    UserName: string;
    LastName: string;
    Email: string;
    Password: string;
    NewPassword: string;
    IsEmailIdPresent: boolean;
    UID: string;
}

